if (window.trip_archive_script_data.query_string === "0") {
  localStorage.removeItem('tour');
  localStorage.removeItem('destination');
  localStorage.removeItem('date_from');
  localStorage.removeItem('date_to');
  localStorage.removeItem('price_from');
  localStorage.removeItem('price_to');
}

import $ from 'jquery';

window.$ = window.jQuery = $;
import 'jquery-ui';
// import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/slider.js';

$(function () {
  // let dateFormat = 'mm/dd/yy';
  //
  // let date_from = $('#date_from')
  //   .datepicker({
  //     defaultDate: '+1w',
  //     changeMonth: true,
  //     numberOfMonths: 3
  //   });
  //
  // let date_to = $('#date_to').datepicker({
  //   defaultDate: '+1w',
  //   changeMonth: true,
  //   numberOfMonths: 3
  // });
  //
  // date_from.on('change', function () {
  //   date_to.datepicker('option', 'minDate', getDate(this));
  // });
  //
  // date_to.on('change', function () {
  //   date_from.datepicker('option', 'maxDate', getDate(this));
  // });
  //
  // function getDate (element) {
  //   let date;
  //
  //   try {
  //     date = $.datepicker.parseDate(dateFormat, element.value);
  //   } catch (error) {
  //     date = null;
  //   }
  //
  //   return date;
  // }

  let trip_filter_price_minimum = parseInt(window.trip_archive_script_data.trip_filter_price_minimum);
  let trip_filter_price_maximum = parseInt(window.trip_archive_script_data.trip_filter_price_maximum);

  let values_array = [];

  if (localStorage.getItem('price_from') && localStorage.getItem('price_to')) {
    values_array = [
      parseInt(localStorage.getItem('price_from')),
      parseInt(localStorage.getItem('price_to'))
    ];
  } else {
    values_array = [
      trip_filter_price_minimum,
      trip_filter_price_maximum
    ];
  }

  let slider = $('#slider-range').slider({
    range: true,
    min: trip_filter_price_minimum,
    max: trip_filter_price_maximum,
    values: values_array,
    slide: function (event, ui) {
      $('#amount').val('$' + ui.values[0] + ' - $' + ui.values[1]);
      $('#price_from').val(ui.values[0]);
      $('#price_to').val(ui.values[1]);
      localStorage.setItem('price_from', ui.values[0]);
      localStorage.setItem('price_to', ui.values[1]);
    }
  });

  $('#amount').val('$' + $('#slider-range').slider('values', 0) + ' - $' + $('#slider-range').slider('values', 1));

  slider.on('change', function (event, ui) {

  });
});

import Vue from 'vue';
import VCalendar from 'v-calendar';

Vue.use(VCalendar);

new Vue({
  el: '#filter',
  template: `
    <div class="bg-curious-blue py-[50px] px-[20px] mb-[25px] lg:mb-0">
    <form ref="form">
      <div class="font-primary font-semibold text-[21px] text-white pb-[10px]">{{ trip_filter_title_1 }}</div>
      <div class="font-primary font-light text-[14px] text-white pb-[30px]" v-html="trip_filter_content_1"></div>
      <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
        </svg>
        <input v-model="tour" v-bind:placeholder="trip_filter_placeholder_1" name="tour" type="text" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none">
      </div>
      <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/>
        </svg>
        <input v-model="destination" v-bind:placeholder="trip_filter_placeholder_2" name="destination" type="text" class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none">
      </div>
      <v-date-picker v-model="range" mode="date" is-range v-bind:model-config="modelConfig" v-bind:masks="masks">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
            <input
                v-on="inputEvents.start"
                v-bind:value="inputValue.start"
                v-bind:placeholder="trip_filter_placeholder_3"
                name="date_from" type="text" id="date_from"
                class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none"
            />
          </div>
          <div class="flex items-center min-h-[50px] bg-timberwolf bg-opacity-[20%] mb-[5px]">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-white ml-[20px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
            </svg>
            <input
                v-bind:value="inputValue.end"
                v-on="inputEvents.end"
                class="font-primary font-light text-[14px] text-white placeholder-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none"
                name="date_to" type="text" id="date_to"
                v-bind:placeholder="trip_filter_placeholder_4"/>
          </div>
        </template>
      </v-date-picker>
      <div class="font-primary font-semibold text-[21px] text-white pt-[30px] pb-[10px]">{{ trip_filter_title_2 }}</div>
      <div class="mx-[10px]" id="slider-range"></div>
      <div class="flex items-center min-h-[50px] bg-curious-blue bg-opacity-[100%] mb-[5px]">
        <div class="font-primary font-light text-[14px] text-white mr-[5px] whitespace-nowrap">
          {{ trip_filter_placeholder_5 }}
        </div>
        <input class="font-primary font-light text-[14px] text-white w-full h-full bg-transparent border-none rounded-none focus:outline-none focus-within:outline-none" type="text" id="amount" readonly>
      </div>
      <input name="price_from" id="price_from" type="hidden" value="">
      <input name="price_to" id="price_to" type="hidden" value="">
      <div v-on:click="reset" class="w-full inline-flex items-center justify-center self-center font-primary font-light text-[14px] text-white uppercase bg-allports py-[15px] pl-[30px] pr-[25px] border-[1px] border-allports rounded-none mt-[40px] mb-[5px] transition-all ease-in-out duration-300 hover:text-allports hover:bg-white hover:border-allports">
        {{ trip_filter_label_2 }}
      </div>
      <button v-on:click="submit" class="w-full inline-flex items-center justify-center self-center font-primary font-light text-[14px] text-white uppercase bg-allports py-[15px] pl-[30px] pr-[25px] border-[1px] border-allports rounded-none outline-none mb-[40px] mb-[5px] transition-all ease-in-out duration-300 hover:text-allports hover:bg-white hover:border-allports">
        {{ trip_filter_label_1 }}
      </button>
    </form>
    </div>`,
  data () {
    return {
      trip_filter_title_1: window.trip_archive_script_data.trip_filter_title_1,
      trip_filter_title_2: window.trip_archive_script_data.trip_filter_title_2,
      trip_filter_content_1: window.trip_archive_script_data.trip_filter_content_1,
      trip_filter_placeholder_1: window.trip_archive_script_data.trip_filter_placeholder_1,
      trip_filter_placeholder_2: window.trip_archive_script_data.trip_filter_placeholder_2,
      trip_filter_placeholder_3: window.trip_archive_script_data.trip_filter_placeholder_3,
      trip_filter_placeholder_4: window.trip_archive_script_data.trip_filter_placeholder_4,
      trip_filter_placeholder_5: window.trip_archive_script_data.trip_filter_placeholder_5,
      trip_filter_label_1: window.trip_archive_script_data.trip_filter_label_1,
      trip_filter_label_2: window.trip_archive_script_data.trip_filter_label_2,
      trip_filter_archive_link: window.trip_archive_script_data.trip_filter_archive_link,
      query_string: window.trip_archive_script_data.query_string,
      range: {
        start: localStorage.getItem('date_from') ? localStorage.getItem('date_from') : '',
        end: localStorage.getItem('date_to') ? localStorage.getItem('date_to'): '',
        // start: (new Date()).toLocaleDateString('en-GB'),
        // end: (new Date()).toLocaleDateString('en-GB'),
      },
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      masks: {
        input: 'DD/MM/YYYY',
      },
      tour: '',
      destination: '',
      price_from: '',
      price_to: '',
    };
  },
  methods: {
    reset () {
      localStorage.removeItem('tour');
      localStorage.removeItem('destination');
      localStorage.removeItem('date_from');
      localStorage.removeItem('date_to');
      localStorage.removeItem('price_from');
      localStorage.removeItem('price_to');

      window.location.href = this.trip_filter_archive_link;
    },
    submit () {
      localStorage.setItem('tour', this.tour);
      localStorage.setItem('destination', this.destination);
      localStorage.setItem('date_from', this.range.start);
      localStorage.setItem('date_to', this.range.end);
      // localStorage.setItem('price_from', this.price_from);
      // localStorage.setItem('price_to', this.price_to);

      this.$refs.form.submit();
    }
  },
  mounted () {
    if (localStorage.getItem('tour')) {
      this.tour = localStorage.getItem('tour');
    }

    if (localStorage.getItem('destination')) {
      this.destination = localStorage.getItem('destination');
    }

    // if (localStorage.getItem('date_from')) {
    //   this.range.start = localStorage.getItem('date_from');
    // }
    //
    // if (localStorage.getItem('date_to')) {
    //   this.range.end = localStorage.getItem('date_to');
    // }

    if (localStorage.getItem('price_from')) {
      this.price_from = localStorage.getItem('price_from');
    }

    if (localStorage.getItem('price_to')) {
      this.price_to = localStorage.getItem('price_to');
    }
  }
});
